module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card__table"
  }, [_c('vue-audio', {
    ref: "clickCard",
    attrs: {
      "file": 3
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card__action"
  }, [_c('div', {
    staticClass: "horse_user horse_preview",
    class: _vm.horseColor
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDecisionCardScreen),
      expression: "isDecisionCardScreen"
    }]
  }, [_vm._v("あなたのユニコーン")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isDecisionCardScreen),
      expression: "isDecisionCardScreen"
    }],
    staticClass: "horse_pc horse_preview horse-06"
  }, [_c('p', [_vm._v("競争相手のユニコーン")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentScreen !== 'decisionCard'),
      expression: "currentScreen !== 'decisionCard'"
    }],
    staticClass: "card__list"
  }, [_c('ul', {}, [_c('li', {
    staticClass: "card__item card__name"
  }, [_vm._v("第一染色体")]), _vm._v(" "), _c('li', {
    staticClass: "card__item card__name"
  }, [_vm._v("第二染色体")]), _vm._v(" "), _c('li', {
    staticClass: "card__item card__name"
  }, [_vm._v("第三染色体")]), _vm._v(" "), _c('li', {
    staticClass: "card__item card__name"
  }, [_vm._v("性染色体")]), _vm._v(" "), _c('li', {
    staticClass: "card__item"
  }, [_c('card-item', {
    attrs: {
      "id": "A1",
      "itemCard": _vm.itemCard.A1
    },
    on: {
      "click": function($event) {
        _vm.click('A1')
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "B1",
      "itemCard": _vm.itemCard.B1
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "C1",
      "itemCard": _vm.itemCard.C1
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "D1",
      "itemCard": _vm.itemCard.D1
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item"
  }, [_c('card-item', {
    attrs: {
      "id": "A2",
      "itemCard": _vm.itemCard.A2
    },
    on: {
      "click": function($event) {
        _vm.click('A2')
      }
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "B2",
      "itemCard": _vm.itemCard.B2
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "C2",
      "itemCard": _vm.itemCard.C2
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "card__item",
    class: _vm.inactiveCard
  }, [_c('card-item', {
    attrs: {
      "id": "D2",
      "itemCard": _vm.itemCard.D2
    }
  })], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-242ba374","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CardList.vue
// module id = 74
// module chunks = 0